import { Button } from "@/components/ui/button";
import { MapPin, Heart, ChevronRight, Navigation } from "lucide-react";

export function DestinationCard({ dest, isSelected, onToggleFavorite, onSelect, onNavigate, onDirections }) {
  return (
    <div
      className={`bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-md transition-shadow cursor-pointer ${
        isSelected ? 'ring-2 ring-accent' : ''
      }`}
      onClick={onSelect}
      data-testid={`panel-destination-${dest.id}`}
    >
      <div className="flex">
        <div className="relative w-32 min-h-[140px] flex-shrink-0">
          <img 
            src={dest.image_url} 
            alt={`${dest.name} - fly fishing in ${dest.state}`}
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <button
            onClick={onToggleFavorite}
            className="absolute top-2 left-2 p-1.5 bg-white/90 rounded-full shadow-md hover:bg-red-50 transition-colors"
            data-testid={`panel-destination-save-${dest.id}`}
          >
            <Heart className="w-4 h-4 text-gray-400" />
          </button>
        </div>
        
        <div className="flex-1 p-4 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div className="min-w-0 flex-1">
              <h3 className="font-serif text-lg font-medium text-gray-900 line-clamp-1">{dest.name}</h3>
              <p className="text-sm text-gray-500 flex items-center gap-1">
                <MapPin className="w-3 h-3 flex-shrink-0" />
                <span className="truncate">{dest.state}</span>
              </p>
            </div>
          </div>
          
          <p className="text-sm text-gray-600 line-clamp-2 mb-3">
            {dest.description}
          </p>
          
          {dest.target_species?.length > 0 && (
            <div className="flex flex-wrap gap-1 mb-3">
              {dest.target_species.slice(0, 3).map(sp => (
                <span key={sp} className="text-xs px-2 py-0.5 bg-primary/10 text-primary rounded-full">
                  {sp}
                </span>
              ))}
            </div>
          )}
          
          <div className="flex gap-2">
            <Button
              size="sm"
              onClick={(e) => {
                e.stopPropagation();
                onNavigate(dest);
              }}
              className="text-xs bg-accent text-accent-foreground hover:bg-accent/90 flex-1"
            >
              View Details
              <ChevronRight className="w-3 h-3 ml-1" />
            </Button>
            <Button
              size="icon"
              variant="outline"
              onClick={(e) => onDirections(dest, e)}
              className="h-8 w-8 flex-shrink-0"
              title="Get Directions"
            >
              <Navigation className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
